import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ClientPage } from "../../components/client/ClientUiViewClient";

/**
 * Página 404 para todos los roles (con su sidebar): rutas que no existen y, para
 * el cliente, las que no son de su vista.
 */
const NotFoundViewClient: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  // Si se ha entrado directamente por la URL, no hay a dónde volver.
  const canGoBack = location.key !== "default";

  return (
    <ClientPage>
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 2,
          maxWidth: 480,
          mx: "auto",
        }}
      >
        <Typography
          aria-hidden
          sx={{
            fontSize: { xs: 96, md: 140 },
            fontWeight: 800,
            lineHeight: 1,
            letterSpacing: "-0.04em",
            fontVariantNumeric: "tabular-nums",
            color: theme.palette.primary.main,
          }}
        >
          {t("notFound.code")}
        </Typography>
        <Typography component="h1" sx={{ fontSize: 26, fontWeight: 700 }}>
          {t("notFound.title")}
        </Typography>
        <Typography sx={{ fontSize: 16, color: "text.secondary" }}>
          {t("notFound.message")}
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 1.5,
          }}
        >
          <Button
            variant="contained"
            disableElevation
            onClick={() => navigate("/")}
            sx={{
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 700,
              px: 4,
              py: 1.25,
            }}
          >
            {t("notFound.home")}
          </Button>
          {canGoBack && (
            <Button
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 999,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
                py: 1.25,
              }}
            >
              {t("notFound.back")}
            </Button>
          )}
        </Box>
      </Box>
    </ClientPage>
  );
};

export default NotFoundViewClient;
